import styled, { injectGlobal } from 'react-emotion';
import { space, color, width } from 'styled-system';
import { TreeSelect } from 'antd';

export const ScenarioDropdown = styled(TreeSelect)` &&& {
  margin-right: 15px;
  ${space}
  ${color}
  ${width}

  > * {
    vertical-align: middle;
  }
}`;

export const DCRPINavBarPopoverStyle = injectGlobal`
  .DCRPScenarioOption {
    .ant-select-dropdown-search {
      padding: 10px !important;
      position: absolute !important;
      top: 0 !important;
    }

    .ant-select-tree {
      margin-top: 50px;
      overflow-y: scroll !important;
      height: 330px;
    }

    .ant-select-tree-switcher {
      display: none !important;
    }

    .ant-select-tree-node-content-wrapper {
      width: 100% !important;
    }
  }
`;
